/*
 * <seatfit-other-products> (blocks/product_other-products.liquid): "Other Products For Your {vehicle}". Reads the
 * vehicle from the page link like the vehicle steps block (?year&make&model), looks it up in the other products'
 * vehicle data and shows a card for each product that has it: price for that car + CUSTOMIZE to the same vehicle on
 * that product. No card = the whole box stays hidden. Rules: seatfit-other-products-prices.js (loaded before).
 * It starts once the buy box announced its vehicle ('seatfit:vehicle', also after a year change) or at window load
 * without one, so the other products' files never compete with the vehicle data the Buy button waits for.
 */
(function () {
  'use strict';
  if (customElements.get('seatfit-other-products')) return;
  var P = window.SeatFitOtherProducts;
  var KINDS = ['seat', 'cover', 'mat'];

  function whenCore(cb) {
    if (window.SeatFit && window.SeatFit.stepsFor) return cb();
    document.addEventListener('seatfit:ready', function () { cb(); }, { once: true });
  }

  class SeatfitOtherProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.onVehicle = () => whenCore(() => this.refresh());
      document.addEventListener('seatfit:vehicle', this.onVehicle);
      // The buy box can announce its car a few ms before this element is defined (its script loads first); then
      // waiting for window load left the box empty for ~14 s on a slow phone and pushed the page down when it came.
      var steps = document.querySelector('seatfit-vehicle-steps');
      if (document.readyState === 'complete' || (steps && steps.ctx && !steps.loading)) this.onVehicle();
      if (document.readyState !== 'complete') window.addEventListener('load', this.onVehicle, { once: true });
    }

    disconnectedCallback() {
      document.removeEventListener('seatfit:vehicle', this.onVehicle);
      window.removeEventListener('load', this.onVehicle);
      this.started = false;
      this.key = null;
      this.token = (this.token || 0) + 1; // answers still in flight belong to the old render
    }

    refresh() {
      var SF = window.SeatFit;
      if (!P || !SF || !SF.readParams || !window.SeatFitPickerLists) return this.paint(null);
      var p = SF.readParams();
      var q = { year: p.year, make: p.make, model: p.model };
      var key = [q.year, q.make, q.model].join('|');
      if (key === this.key) return; // the same car announced again (load after the buy box, for instance)
      this.key = key;
      var token = this.token = (this.token || 0) + 1;
      Promise.all(KINDS.map((k) => SF.resolve(q, k))).then((list) => {
        if (token !== this.token) return;
        var ctxs = {};
        KINDS.forEach((k, i) => { ctxs[k] = list[i]; });
        // A download that failed is retried on the next announcement instead of hiding the box for the visit.
        if (list.some((c) => c && c.reason === 'load-failed')) this.key = null;
        this.paint(P.view(SF.kind(), ctxs, location.href));
      }).catch((e) => {
        console.warn('[SeatFit] other products could not load', e);
        if (token === this.token) { this.key = null; this.paint(null); }
      });
    }

    // view = P.view(): cards whose product has the car show; the seat card keeps the price Liquid printed.
    paint(view) {
      var fmt = this.getAttribute('data-money-format') || '';
      var byKind = {};
      ((view && view.cards) || []).forEach((c) => { byKind[c.kind] = c; });
      this.querySelectorAll('[data-sf-op-card]').forEach((el) => {
        var c = byKind[el.getAttribute('data-kind')];
        el.hidden = !(c && c.show);
        if (el.hidden) return;
        var link = el.querySelector('[data-sf-op-link]');
        if (link) link.setAttribute('href', c.href);
        if (c.price != null) this.price(el, P.money(c.price, fmt), c.compareAt != null ? P.money(c.compareAt, fmt) : '');
      });
      var line = this.querySelector('[data-sf-op-vehicle]');
      if (line) line.textContent = (view && view.line) || '';
      var show = !!(view && view.show);
      var note = this.querySelector('[data-sf-op-note]');
      if (note) note.hidden = show;
      // The theme editor keeps the box on screen with its note, so it stays selectable; the shop hides it.
      this.hidden = !show && !this.hasAttribute('data-design-mode');
    }

    price(card, now, was) {
      var row = card.querySelector('[data-sf-op-price]');
      var nowEl = card.querySelector('[data-sf-op-now]');
      var wasEl = card.querySelector('[data-sf-op-was]');
      if (nowEl) nowEl.textContent = now;
      if (wasEl) { wasEl.textContent = was; wasEl.hidden = !was; }
      if (row) row.hidden = !now;
    }
  }

  customElements.define('seatfit-other-products', SeatfitOtherProducts);
})();
